/**
 * Lightweight replacement for redux-localstore.
 * Persists the full Redux state to localStorage under `reduxStore`
 * (same key already used by app-services/store/state).
 */
export default function storeSynchronize(store, options = {}) {
  const storage =
    options.storage === "sessionStorage" ? sessionStorage : localStorage;
  const key = options.key || "reduxStore";
  const { blacklist = [], whitelist } = options;

  const pickState = (state) => {
    if (Array.isArray(whitelist) && whitelist.length) {
      return whitelist.reduce((acc, k) => {
        if (k in state) acc[k] = state[k];
        return acc;
      }, {});
    }
    if (Array.isArray(blacklist) && blacklist.length) {
      return Object.keys(state).reduce((acc, k) => {
        if (!blacklist.includes(k)) acc[k] = state[k];
        return acc;
      }, {});
    }
    return state;
  };

  store.subscribe(() => {
    try {
      storage.setItem(key, JSON.stringify(pickState(store.getState())));
    } catch {
      // Quota / private mode — ignore
    }
  });
}

export function defineState(defaultState) {
  return () => {
    try {
      const raw = localStorage.getItem("reduxStore");
      if (!raw) return defaultState;
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object"
        ? { ...defaultState, ...parsed }
        : defaultState;
    } catch {
      return defaultState;
    }
  };
}

export function getState() {
  try {
    return JSON.parse(localStorage.getItem("reduxStore") || "{}");
  } catch {
    return {};
  }
}

export function resetState() {
  localStorage.removeItem("reduxStore");
}
